// extracted by mini-css-extract-plugin
export default {"Background":"Loading_Background__WbSga"};